import React from 'react';

import { makeStyles, createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { DialogProps } from '@material-ui/core/Dialog/Dialog';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons//Check';
import Typography from '@material-ui/core/Typography';

import Grid from '@material-ui/core/Grid';

/**
 * 使用例
 */
// const [open, setOpen] = React.useState(false);

// const handleClickOpen = () => {
//   setOpen(true);
// };
// const handleClose = () => {
//   setOpen(false);
// };

//  <SimpleDialog open={open} onClose={handleClose} title={'タイトルです'} okText="閉じる">
//    <Typography>Hello body</Typography>
//  </SimpleDialog>;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    hiddenScroll: {
      overflow: 'hidden',
    },
    dialogPaper: {
      // minHeight: '50vh',
      // maxHeight: '50vh',
      //height: '400px',
    },
  })
);

type DialogTitleProps = {
  children: React.ReactNode;
  onClose: () => void;
};

const DialogTitle: React.FC<DialogTitleProps> = (props) => {
  const { children, onClose, ...other } = props;
  const classes = useStyles(props);
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
    </MuiDialogTitle>
  );
};

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export type OKCancelDialogProps = {
  /**画面外にマウスをクリックで画面を閉じる */
  autoClose?: boolean;
  /**ダイアログタイトル */
  title?: React.ReactNode | React.ReactNodeArray;
  /**ダイアログコンテント */
  children?: React.ReactNode | React.ReactNodeArray;
  /**ダイアログフッター　未使用 */
  footer?: React.ReactNode | React.ReactNodeArray;
  /**ボタン表示 */
  okText?: string;
  /**ボタン表示 */
  cancelText?: string;
  /**表示/非表示コントロール用 */
  open: boolean;
  /**画面外にマウスをクリックで画面を閉じる */
  maxWidth?: DialogProps['maxWidth'];
  onOK: () => void;
  onCancel: () => void;
};

export const OKCancelDialog: React.FC<OKCancelDialogProps> = (props) => {
  const classes = useStyles();
  const { autoClose = false, title, open, children, okText, cancelText, maxWidth = 'md', onOK, onCancel } = props;
  return (
    <Dialog
      classes={{ paper: classes.dialogPaper }}
      onClose={(e) => {
        if (autoClose) {
          onCancel();
        }
      }}
      open={open}
      fullWidth={true}
      maxWidth={maxWidth}
    >
      <DialogTitle onClose={onCancel}>{title}</DialogTitle>
      <DialogContent dividers className={classes.hiddenScroll}>
        {children}
      </DialogContent>
      <DialogActions>
        {okText && (
          <Button autoFocus variant="contained" color="primary" startIcon={<CheckIcon />} onClick={onOK}>
            {okText}
          </Button>
        )}
        {cancelText && (
          <Button autoFocus variant="contained" color="secondary" startIcon={<CloseIcon />} onClick={onCancel}>
            {cancelText}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
export default OKCancelDialog;
